let searchFilter = {};

(function (searchFilterApp) {
    const filterModel = {
        CurrentPage: 1,
        SearchTerm: "",
    }

    let fromPopState = false;
    let blockPopstateEvent = true;
    const browserSupportsHistoryApi = window.history && 'pushState' in window.history;
    if (browserSupportsHistoryApi) {
        // prevent Chrome from calling onpopstate on initial load
        $(window).on('load', function () {
            // The timeout ensures that popstate-events will be unblocked right
            // after the load event occured, but not in the same event-loop cycle.
            setTimeout(function () { blockPopstateEvent = false; }, 0);
        });

        $(window).on('popstate', function () {
            if (blockPopstateEvent && document.readyState === "complete") {
                return;
            }
            fromPopState = true;
            performSearchFromUrl();
        });
    }

    function pushHistory() {
        if (browserSupportsHistoryApi && !fromPopState) {
            const currentPath = window.location.pathname;
            let query = "?";
            const queryArray = [];
            if (filterModel.CurrentPage && filterModel.CurrentPage > 1) {
                queryArray.push("page=" + filterModel.CurrentPage);
            }
            if (filterModel.SearchTerm) {
                queryArray.push("search=" + filterModel.SearchTerm);
            }
            query += queryArray.join("&");
            history.pushState(null, null, currentPath + query);
        }
        fromPopState = false;
    }

    function performSearchFromUrl() {
        filterModel.CurrentPage = 1;
        filterModel.SearchTerm = "";
        if (window.location.search.length > 1) {
            for (let aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
                nKeyId < aCouples.length;
                nKeyId++) {
                aItKey = aCouples[nKeyId].split("=");
                if (aItKey.length <= 1)
                    continue;
                const key = decodeURIComponent(aItKey[0]).toLowerCase();
                const val = decodeURIComponent(aItKey[1]);

                if (key === "page") {
                    filterModel.CurrentPage = val;
                } else if (key === "search") {
                    filterModel.SearchTerm = val;
                }
            }
        }
        
        searchFilterApp.GetSearchResult();
    }

    searchFilterApp.GetSearchResult = function () {
        $.ajax({
            url: "/umbraco/surface/SearchSurface/GetFilterResult",
            type: "GET",
            data: filterModel,
            dataType: "html",
            success: function (data) {
                $(".js-search-results").html(data);
                $(".js-search-term").text(filterModel.SearchTerm);
                setCount();
                
                pushHistory();
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    };

    function setCount() {
        const count = $(".js-search-grid").data("searchcount");
        $(".js-search-count").text(count);
    }

    $(document).ready(function () {

        //Get url params on load
        const urlParams = new URLSearchParams(window.location.search);

        //check if querystring params exist on load/reload
        if (urlParams.get('page'))
            filterModel.CurrentPage = urlParams.get('page');

        if (urlParams.get('search'))
            filterModel.SearchTerm = urlParams.get('search');

        setCount();

        $(".js-search-field-search-button").on('click', function () {
            $("#search-form").submit();
            $("#search-field").focus();
        });

        $(".js-search-field-clear-button").on('click', function () {
            $("#search-field").val("");
            $("#search-field").focus();
        });

        $(document).on("submit", "#search-form", function (e) {
            e.preventDefault();
            filterModel.SearchTerm = $("#search-field").val();
            filterModel.CurrentPage = 1;
            searchFilterApp.GetSearchResult();
        });

        // pagination
        $(document).on('click', 'ul.pagination a', function (e) {
            e.preventDefault();
            filterModel.CurrentPage = $(this).data('page');
            filterModel.SearchTerm = $("#search-field").val();
            searchFilterApp.GetSearchResult();
            paginationScrollToTop();
        });

        function paginationScrollToTop() {
            $('html, body').animate({
                scrollTop: $(".js-search-results").offset().top - $("header").outerHeight()
            }, 400);
        }
    });

})(searchFilter);
